import axios from "axios";
import React, { useContext, useState } from "react";
import { MyContext } from "../../../context/MyContext";


const NomineeDetail = ({ onClose }) => {
  const { getNomineeDetail } = useContext(MyContext);

  const [nomineeName, setNomineeName] = useState("");
  const [nomineeAddress, setNomineeAddress] = useState("");
  const [nomineeDob, setNomineeDob] = useState("");
  const [aadharNumber, setAadharNumber] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [aadharFront, setAadharFront] = useState(null);
  const [addharBack, setAadharBack] = useState(null);
  const [pan, setPan] = useState(null);
  const [errors, setErrors] = useState({});
  const userId = localStorage.getItem("userId");

  const validate = () => {
    const newErrors = {};
    if (!nomineeName.trim()) {
      newErrors.nomineeName = "Nominee Nme is required";
    }
    if (!nomineeAddress.trim()) {
      newErrors.nomineeAddress = "Nominee Address required";
    }
    if (!nomineeDob.trim()) {
      newErrors.nomineeDob = "Nominee Date of birth required";
    }
    if (!aadharNumber.trim()) {
      newErrors.aadharNumber = "Nominee aadhar number required";
    }
    if (!panNumber.trim()) {
      newErrors.panNumber = "Pan number is required";
    }
    if (!aadharFront) newErrors.aadharFront = "Aadhaar front image is required";
    if (!addharBack) newErrors.addharBack = "Aadhaar back image is required";
    if (!pan) newErrors.pan = "PAN image is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAdharFront = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAadharFront(e.target.files[0]);
    }
  };

  const hanndleAdharBack = (e) => {
    const file = e.target.files[0];
    if (file) {
      setAadharBack(e.target.files[0]);
    }
  };
  const handlePanImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(file);
      setPan(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(nomineeName,nomineeAddress,nomineeDob);
    if (!validate()) return;
    console.log(nomineeAddress, nomineeDob, nomineeName);
    const formData = new FormData();
    formData.append("nomineeName", nomineeName);
    formData.append("nomineeAddress", nomineeAddress);
    formData.append("nomineeDob", nomineeDob);
    formData.append("nomineeAddharNumer", aadharNumber);
    formData.append("panNumber", panNumber);
    formData.append("addharFront", aadharFront);
    formData.append("addharBack", addharBack);
    formData.append("pan", pan);

    await axios
      .post(
        `${process.env.REACT_APP_NODE}user/nomineeDetails/${userId}`,
        formData
      )
      .then((response) => {
        console.log(response.data);
        onClose();
        getNomineeDetail();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[50%] relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-600  text-xl"
        >
          ✖
        </button>

        <h2 className="text-xl font-semibold text-center mb-4">
          Nominee Detail
        </h2>

        <form className="flex flex-col gap-4">
          <div className="flex w-full gap-2  ">
            <div className="w-1/2">
              <label className="block font-medium">Nominee Name</label>
              <input
                type="text"
                value={nomineeName}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={(e) => {
                  setNomineeName(e.target.value);
                }}
              />
              {errors.nomineeName && (
                <p className="text-red-500 text-sm">{errors.nomineeName}</p>
              )}
            </div>
            <div className="w-1/2">
              <label className="block font-medium">Address</label>
              <input
                type="text"
                value={nomineeAddress}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={(e) => {
                  setNomineeAddress(e.target.value);
                }}
              />
              {errors.nomineeAddress && (
                <p className="text-red-500 text-sm">{errors.nomineeAddress}</p>
              )}
            </div>
          </div>
          <div className="flex w-full gap-2  ">
            <div className="w-1/2">
              <label className="block font-medium"> DOB</label>
              <input
                type="date"
                value={nomineeDob}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                placeholder="DD/MM/YY"
                onChange={(e) => {
                  console.log(e.target.value);
                  setNomineeDob(e.target.value);
                }}
              />
              {errors.nomineeDob && (
                <p className="text-red-500 text-sm">{errors.nomineeDob}</p>
              )}
            </div>
            <div className="w-1/2">
              <label className="block font-medium">Aadhar Number</label>
              <input
                type="text"
                value={aadharNumber}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={(e) => {
                  setAadharNumber(e.target.value);
                }}
              />
              {errors.aadharNumber && (
                <p className="text-red-500 text-sm">{errors.aadharNumber}</p>
              )}
            </div>
          </div>
          <div className="flex w-full gap-2  ">
            <div className="w-1/2">
              <label className="block font-medium">Aadhar Front Image</label>
              <input
                type="file"
                accept="image/*"
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={handleAdharFront}
              />
              {errors.aadharFront && (
                <p className="text-red-500 text-sm">{errors.aadharFront}</p>
              )}
            </div>
            <div className="w-1/2">
              <label className="block font-medium">Aadhar Back Image</label>
              <input
                type="file"
                accept="image/*"
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={hanndleAdharBack}
              />
              {errors.addharBack && (
                <p className="text-red-500 text-sm">{errors.addharBack}</p>
              )}
            </div>
          </div>
          <div className="flex w-full gap-2  ">
            <div className="w-1/2">
              <label className="block font-medium">Pan Number</label>
              <input
                type="text"
                value={panNumber}
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={(e) => {
                  setPanNumber(e.target.value);
                }}
              />
              {errors.panNumber && (
                <p className="text-red-500 text-sm">{errors.panNumber}</p>
              )}
            </div>
            <div className="w-1/2">
              <label className="block font-medium">Pan Image</label>
              <input
                type="file"
                accept="image/*"
                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:border-blue-600"
                onChange={handlePanImage}
              />
              {errors.pan && (
                <p className="text-red-500 text-sm">{errors.pan}</p>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 transition w-full text-white font-semibold rounded-lg py-2"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default NomineeDetail;
